import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesDisableFormForm } from './FormSamplesDisableFormForm';
import { FormSamplesDisableFormPageInfo } from './FormSamplesDisableFormPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
    textBox: string;
    date: string;
    time: string;
    dateTime: string;
    singleSelect: string;
    multipleSelect: string[];
    singleList: string;
    multipleList: string[];
    radioGroup: string;
    slider: number[];
    switch: boolean;
    check: boolean;
    maskTelephone: string;
    maskOther: string;
}

export const FormSamplesDisableFormPage = () => {

    const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
    const [submitting, setSubmitting] = useState(false);
    const { showError } = useFeedback();

    const initialValuesToBePassed: ExampleDto = {
        textBox: "Some text",
        date: "2022-01-01",
        time: "14:20",
        dateTime: "2024-02-02 16:40",
        singleSelect: "Op2",
        multipleSelect: ["Op1", "Op4"],
        singleList: "Op2",
        multipleList: ["Op1", "Op4"],
        radioGroup: "Op2",
        slider: [10, 60],
        switch: false,
        check: true,
        maskTelephone: "(072) 444-88844",
        maskOther: "(123) (321)"
    }

    const handleSubmit = async (values: ExampleDto) => {
        setSubmitting(true);
        setSubmittedValues(values);

        try {
            // In the api call, uncomment the exception in there to test errors coming from the api
            await callMimicApi();
        } catch (ex) {
            showError(`An error occured: ${ex}`);
            return false;
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <PageContainer
            heading='Form Samples - Disable Form'
            icon={<TextSnippetIcon />}
            pageInfo={<FormSamplesDisableFormPageInfo />}
        >
            <PageDefaultSegment width={400}>
                <FormSamplesDisableFormForm
                    initialValues={initialValuesToBePassed}
                    submitting={submitting}
                    onSubmit={handleSubmit}
                />
            </PageDefaultSegment>
            <FormSamplesOutput width={400} submittedValues={submittedValues} />
        </PageContainer>
    )
}
